import React from "react";
// Helper functions
import { initLogger } from "common/Helpers";
// Websocket connections
import { Client } from "@stomp/stompjs";
// Live update
let websocket = null;
const logger = initLogger("appointmentwebsocket");

class AppointmentWebsocket extends React.Component {
  componentDidMount = () => {
    this.connectWebsocket();
  };

  componentWillUnmount = () => {
    this.disconnectWebsocket();
  };

  connectWebsocket = () => {
    const { callback } = this.props;
    let brokerURL;

    switch (process.env.REACT_APP_SETTING) {
      case "prod":
      case "start":
      case "start-prod":
        brokerURL = process.env.REACT_APP_WEBSOCKET_URL_WS_PROD;
        break;
      case "demo":
      case "start-demo":
        brokerURL = process.env.REACT_APP_WEBSOCKET_URL_WS_DEMO;
        break;
      case "kai":
      case "start-local-kai":
        brokerURL = process.env.REACT_APP_WEBSOCKET_URL_KAI;
        break;
      default:
        brokerURL = process.env.REACT_APP_WEBSOCKET_URL_WS_DEV;
    }

    try {
      websocket = new Client();
      websocket.configure({
        brokerURL,
        onConnect: () => {
          logger.warn("Connected to", brokerURL);
          websocket.subscribe(
            process.env.REACT_APP_WEBSOCKET_SUBSCRIBE,
            callback
          );
        },
      });

      websocket.activate();
    } catch (connectException) {      
      logger.warn(connectException, brokerURL);
    }
  };

  callWebsocket = (appointmentId) => {
    try {
      const destination = process.env.REACT_APP_WEBSOCKET_PUBLISH;
      logger.info("SENDING MESSAGE", destination);
      websocket.publish({
        destination,
        body: appointmentId,
      });
    } catch (sendException) {
      logger.warn(sendException);
    }
  };

  disconnectWebsocket = () => {
    try {
      if (websocket) {
        websocket.deactivate();
      }
    } catch (discoException) {
      logger.warn(discoException);
    }
  };

  render = () => {
    return false;
  };
}

export default AppointmentWebsocket;
